import React from 'react';
import { OnboardingDialogBase } from './OnboardingDialogBase';

export interface IAIDisabledDialogProps {
	onClose: () => void;
	stepText?: string;
}

export const AIDisabledDialog: React.FC<IAIDisabledDialogProps> = ({
	onClose,
	stepText,
}) => {
	return (
		<OnboardingDialogBase
			title="AI features temporarily disabled"
			badgeText="Notice"
			stepText={stepText}
			onAcknowledge={onClose}
		>
			<p>
				We are currently upgrading our AI generation features. As a result, the AI node generation functionality is temporarily disabled.
			</p>
			<p>
				<strong>We were having capacity issues and expect to have a solution within two weeks.</strong>
			</p>
			<p>
				We apologize for the inconvenience and appreciate your patience as we work to bring you an even better experience.
			</p>
		</OnboardingDialogBase>
	);
};

export default AIDisabledDialog;
